export const comics = [
  {
    id: "starry-sea-love",
    title: "星海恋语",
    author: "藤井树",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20girl%20with%20long%20silver%20hair%20under%20a%20starry%20night%20sky%2C%20romantic%20soft%20pink%20and%20warm%20tones%2C%20clean%20minimal%20light%20background%2C%20vertical%20comic%20cover%20artwork%2C%20delicate%20line%20art&width=480&height=640&seq=comic-cover-01&orientation=portrait",
    category: "romance",
    tags: ["恋爱", "校园", "治愈", "青春"],
    status: "ongoing",
    region: "日漫",
    year: 2026,
    updatedAt: "2026-10-12",
    views: 12840000,
    rating: 9.6,
    description: "转学生凉宫遥带着一个关于流星的秘密来到海边的星见高中。她与天文社的男孩相遇在每一个晴朗的夜晚，用望远镜读懂了彼此沉默的心事。这是一个关于约定、等待与星空的温柔恋爱故事。",
    chapterCount: 68,
    featured: true,
  },
  {
    id: "dragon-abyss-song",
    title: "龙渊剑歌",
    author: "墨白",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20young%20swordsman%20holding%20a%20glowing%20dragon%20sword%2C%20epic%20fantasy%20atmosphere%2C%20warm%20orange%20and%20deep%20shadow%20tones%2C%20clean%20minimal%20dark%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-02&orientation=portrait",
    category: "fantasy",
    tags: ["奇幻", "武侠", "热血", "冒险"],
    status: "ongoing",
    region: "国漫",
    year: 2025,
    updatedAt: "2026-10-11",
    views: 9620000,
    rating: 9.4,
    description: "少年林渊在龙渊谷底拾得一柄沉眠千年的断剑，从此踏上寻找真龙血脉的旅程。剑气所指，恩怨情仇；山河万里，唯我剑歌。",
    chapterCount: 112,
    featured: true,
  },
  {
    id: "burning-high-school",
    title: "热血高校年代记",
    author: "高桥凉介",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20delinquent%20high%20school%20boy%20with%20determined%20expression%2C%20dynamic%20action%20pose%2C%20warm%20sunset%20tones%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork%2C%20bold%20line%20art&width=480&height=640&seq=comic-cover-03&orientation=portrait",
    category: "action",
    tags: ["热血", "校园", "格斗", "友情"],
    status: "ongoing",
    region: "日漫",
    year: 2024,
    updatedAt: "2026-10-10",
    views: 8130000,
    rating: 9.2,
    description: "铃兰高中的不良少年们为了顶点的荣耀彼此碰撞。转学生黑泽修一用一双拳头，重新定义了什么叫真正的强大。",
    chapterCount: 96,
    featured: true,
  },
  {
    id: "sakura-time",
    title: "樱色时光",
    author: "小野寺结衣",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20two%20schoolgirls%20in%20cherry%20blossom%20season%2C%20gentle%20pastel%20pink%20palette%2C%20clean%20minimal%20light%20background%2C%20vertical%20comic%20cover%20artwork%2C%20soft%20watercolor%20style&width=480&height=640&seq=comic-cover-04&orientation=portrait",
    category: "girl",
    tags: ["少女", "校园", "恋爱", "唯美"],
    status: "completed",
    region: "日漫",
    year: 2023,
    updatedAt: "2026-09-28",
    views: 6740000,
    rating: 9.3,
    description: "在樱花纷飞的季节里，四个女孩分享了她们的秘密与梦想。青春像花瓣一样短暂，却值得被温柔地记住。",
    chapterCount: 54,
    featured: true,
  },
  {
    id: "city-exorcist",
    title: "都市驱魔人",
    author: "玖月",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20modern%20exorcist%20in%20a%20dark%20city%20street%20at%20night%2C%20mysterious%20mood%2C%20cool%20gray%20and%20warm%20lamp%20light%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-05&orientation=portrait",
    category: "suspense",
    tags: ["悬疑", "灵异", "都市", "战斗"],
    status: "ongoing",
    region: "国漫",
    year: 2025,
    updatedAt: "2026-10-12",
    views: 5920000,
    rating: 9.1,
    description: "深夜的城市里，藏匿在人间的妖怪从未停止活动。驱魔人陆沉游走在霓虹与阴影之间，守护着普通人的安宁。",
    chapterCount: 77,
  },
  {
    id: "roommate-diary",
    title: "合租日记",
    author: "阿宅先生",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20cheerful%20roommates%20in%20a%20cozy%20small%20apartment%2C%20warm%20everyday%20slice%20of%20life%20mood%2C%20clean%20minimal%20bright%20background%2C%20vertical%20comic%20cover%20artwork%2C%20cute%20style&width=480&height=640&seq=comic-cover-06&orientation=portrait",
    category: "daily",
    tags: ["日常", "搞笑", "治愈", "生活"],
    status: "ongoing",
    region: "国漫",
    year: 2026,
    updatedAt: "2026-10-09",
    views: 4310000,
    rating: 8.9,
    description: "三个性格迥异的年轻人挤进一套小公寓，从抢厕所到深夜夜宵，鸡飞狗跳却又无比温暖的合租生活正式开始。",
    chapterCount: 143,
  },
  {
    id: "mecha-era",
    title: "机甲纪元",
    author: "星河",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20giant%20mecha%20robot%20standing%20in%20a%20futuristic%20landscape%2C%20dramatic%20scale%2C%20warm%20orange%20and%20steel%20gray%20tones%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-07&orientation=portrait",
    category: "fantasy",
    tags: ["奇幻", "机甲", "科幻", "热血"],
    status: "ongoing",
    region: "国漫",
    year: 2025,
    updatedAt: "2026-10-08",
    views: 7180000,
    rating: 9.0,
    description: "人类文明在废土之上重建，驾驶机甲抵御异兽的驾驶员被称为最后的希望。少年黎川登上代号「星霜」的机体，命运从此改写。",
    chapterCount: 88,
  },
  {
    id: "coffee-and-cat",
    title: "咖啡与猫",
    author: "夏目铃",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20girl%20barista%20with%20a%20fluffy%20cat%20in%20a%20cozy%20cafe%2C%20warm%20inviting%20mood%2C%20clean%20minimal%20warm%20background%2C%20vertical%20comic%20cover%20artwork%2C%20soft%20lighting&width=480&height=640&seq=comic-cover-08&orientation=portrait",
    category: "daily",
    tags: ["日常", "治愈", "恋爱", "美食"],
    status: "completed",
    region: "日漫",
    year: 2024,
    updatedAt: "2026-09-20",
    views: 3820000,
    rating: 9.2,
    description: "小巷深处的老咖啡馆里，一只橘猫和一位沉默的店主，迎来了形形色色的客人。每一杯咖啡背后，都是一段温柔的故事。",
    chapterCount: 46,
  },
  {
    id: "midnight-diner-tales",
    title: "深夜食堂奇谈",
    author: "安藤圭",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20small%20late%20night%20diner%20with%20warm%20lantern%20glow%2C%20mysterious%20food%20stories%20atmosphere%2C%20clean%20minimal%20dark%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-09&orientation=portrait",
    category: "daily",
    tags: ["日常", "美食", "治愈", "人生"],
    status: "ongoing",
    region: "日漫",
    year: 2026,
    updatedAt: "2026-10-11",
    views: 3540000,
    rating: 9.1,
    description: "只在午夜十二点后开门的小食堂，老板只做客人点的菜。一碗热腾腾的饭，治愈一个又一个深夜无法入睡的灵魂。",
    chapterCount: 62,
  },
  {
    id: "king-blade",
    title: "王者之刃",
    author: "烈焰",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20fierce%20warrior%20king%20with%20a%20giant%20blade%2C%20epic%20battle%20aura%2C%20warm%20crimson%20and%20gold%20tones%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-10&orientation=portrait",
    category: "action",
    tags: ["热血", "战斗", "王者", "史诗"],
    status: "ongoing",
    region: "韩漫",
    year: 2025,
    updatedAt: "2026-10-07",
    views: 8890000,
    rating: 9.3,
    description: "被流放的王子握紧了残缺的王者之刃，决心从深渊杀回王座。荣耀从不属于懦夫，只有最强者才能加冕。",
    chapterCount: 134,
  },
  {
    id: "flower-and-sword",
    title: "花与剑",
    author: "苏璃",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20swordswoman%20surrounded%20by%20falling%20petals%2C%20elegant%20fantasy%20mood%2C%20warm%20rose%20and%20gold%20palette%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-11&orientation=portrait",
    category: "girl",
    tags: ["少女", "奇幻", "古风", "唯美"],
    status: "completed",
    region: "国漫",
    year: 2023,
    updatedAt: "2026-09-15",
    views: 4210000,
    rating: 9.0,
    description: "名门剑阁的独女沈璃被迫替嫁入宫，却在深宫中以一柄软剑揭开惊天阴谋。繁花落尽处，是她自己的江湖。",
    chapterCount: 72,
  },
  {
    id: "campus-mystery-club",
    title: "校园怪谈社",
    author: "谜影",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20students%20investigating%20a%20haunted%20school%20at%20dusk%2C%20eerie%20mysterious%20mood%2C%20cool%20tones%20with%20warm%20accents%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-12&orientation=portrait",
    category: "suspense",
    tags: ["悬疑", "校园", "推理", "灵异"],
    status: "ongoing",
    region: "国漫",
    year: 2026,
    updatedAt: "2026-10-12",
    views: 3110000,
    rating: 8.8,
    description: "废弃的旧校舍每到黄昏就会传出读书声。怪谈社的四名成员决定一探究竟，却发现真相远比传闻更加不可思议。",
    chapterCount: 49,
  },
  {
    id: "sweetheart-idol",
    title: "甜心偶像",
    author: "星野爱",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20bright%20idol%20girl%20on%20stage%20with%20lights%2C%20cheerful%20energetic%20mood%2C%20warm%20pink%20and%20gold%20tones%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-13&orientation=portrait",
    category: "girl",
    tags: ["少女", "恋爱", "偶像", "青春"],
    status: "ongoing",
    region: "日漫",
    year: 2025,
    updatedAt: "2026-10-10",
    views: 5460000,
    rating: 8.9,
    description: "平凡少女意外被星探发现，从零开始追逐舞台梦想。聚光灯下，她遇见了最想成为的自己，也遇见了那个他。",
    chapterCount: 81,
  },
  {
    id: "ark-of-doom",
    title: "末日方舟",
    author: "磐石",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20survivors%20before%20a%20giant%20ark%20in%20a%20ruined%20world%2C%20epic%20apocalyptic%20mood%2C%20warm%20dusty%20orange%20and%20gray%20tones%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-14&orientation=portrait",
    category: "fantasy",
    tags: ["奇幻", "末日", "悬疑", "生存"],
    status: "ongoing",
    region: "韩漫",
    year: 2024,
    updatedAt: "2026-10-06",
    views: 6280000,
    rating: 9.1,
    description: "当最后一座人类方舟升空，留在地表的人只剩下彼此。为了活下去，他们必须回答一个残酷的问题：谁有资格登上明天。",
    chapterCount: 103,
  },
  {
    id: "laughing-campus",
    title: "笑园风云",
    author: "乐乐",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20funny%20students%20causing%20chaos%20in%20a%20classroom%2C%20comedic%20energetic%20mood%2C%20bright%20warm%20colors%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-15&orientation=portrait",
    category: "comedy",
    tags: ["搞笑", "校园", "沙雕", "日常"],
    status: "ongoing",
    region: "国漫",
    year: 2026,
    updatedAt: "2026-10-13",
    views: 2870000,
    rating: 8.7,
    description: "一个永远脑洞大开的班级，一群永远状况百出的同学。每一话都能让你笑到肚子疼，堪称快乐源泉。",
    chapterCount: 158,
  },
  {
    id: "post-office-of-time",
    title: "时光邮局",
    author: "林晚",
    cover: "https://readdy.ai/api/search-image?query=anime%20manga%20cover%20illustration%20of%20a%20nostalgic%20old%20post%20office%20with%20warm%20evening%20light%2C%20gentle%20poetic%20mood%2C%20warm%20amber%20tones%2C%20clean%20minimal%20background%2C%20vertical%20comic%20cover%20artwork&width=480&height=640&seq=comic-cover-16&orientation=portrait",
    category: "romance",
    tags: ["恋爱", "治愈", "奇幻", "催泪"],
    status: "completed",
    region: "国漫",
    year: 2023,
    updatedAt: "2026-09-30",
    views: 4980000,
    rating: 9.4,
    description: "镇上有一间能寄信到过去的邮局。少女成为新的邮差后，一次次把未说出口的心意，送到那些来不及的时刻。",
    chapterCount: 58,
  },
];